import React, { Component } from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames'
import './amazon-link.scss';

class AmazonLink extends Component {

  render() {
    const { link, isInsideTable, onClick, title, className, isBlack, productName } = this.props;

    return (
      <div className="amazon-link__wrapper">
        {/* don't change class .ga-*** to other name since it's tracked by analytics! */}
        <a
          className={classnames('amazon-link', className, {
            'amazon-link--is-table': isInsideTable,
            'amazon-link--is-black': isBlack,
          })}
          target="_blank"
          onClick={onClick ? onClick : () => { }}
          rel="nofollow noopener"
          href={link}
          data-vars-product-name={productName}
        >
          {title}
        </a>
      </div>

    )
  }
}

AmazonLink.propTypes = {
  isInsideTable: PropTypes.bool,
  isBlack: PropTypes.bool,
  onClick: PropTypes.func,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
};

export default AmazonLink;



// WEBPACK FOOTER //
// ./src/components/amazon-link/amazon-link.js